/**
 * SeoArticle Functional Component
 * @Package - seo
 * @Author - Cybage@UPWA-Team
 * @description: Common SEO Article
 */
/**
 *   SEO's Article Component
 */
import React from 'react'
import { useLocation } from 'react-router-dom'
import ArticlesProvider from '../../../contexts/articles.context'
import ArticleComponent from './ArticleComponent'

export default function SeoArticle(dynamicApiData = {}) {
  const {
    id,
    title,
    image,
    data,
    altText,
    attributes,
    images,
    pageType,
  } = dynamicApiData
  const { pathname } = useLocation()
  const articles = data.length ? data : null

  return (
    <ArticlesProvider
      pageType={pageType}
      uri={pathname || ''}
      collection={articles}
      attributes={attributes}
      images={images}
    >
      <ArticleComponent
        id={id}
        title={title}
        image={image}
        data={articles}
        altText={altText}
        pageType={pageType}
        attributes={attributes}
      />
    </ArticlesProvider>
  )
}
